// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (SOP in-app — dibaca tim lapangan di menu "SOP & Bantuan")
// version  : 2.2
// updated  : 2026-09-05
// protected: NO  -> SOP menyeluruh SEMUA alur sekarang (Fase 0..10 + UAT-FIX + Tukar Barang + SOP-21).
//            Bahasa SEDERHANA untuk staff lapangan. Blok "internal" (Proses Internal/Sistem)
//            hanya ditampilkan ke OWNER & KACAB oleh SOPPage.
// =============================================================================
// Konten SOP ringkas per-role (ditampilkan di Dashboard & halaman SOP).
const G = (k) => ["ADMIN_GUDANG_SBY", "ADMIN_GUDANG_SMD"].includes(k);

export const sopForRole = (role) => {
  if (role === "OWNER") return {
    title: "SOP Kontrol & Audit (Owner)",
    points: [
      "Pantau ledger, laporan penjualan & mutasi per region.",
      "Kelola Master Diskon (semua region). Harga jual: Owner HANYA MELIHAT (revisi harian = wewenang mutlak Staff Store store-nya); bila perlu bertindak, Owner masuk lewat Assist Mode sebagai Staff Store (tercatat atas nama Owner).",
      "Owner read-only untuk transaksi operasional harian (kasir 403).",
      "Piutang Bayar Nanti: pantau rekap per region; hanya Owner yang dapat \"Force Bill\" (paksa masuk tagihan, alasan wajib) saat klub ambil alih tanggung jawab.",
      "Setujui perubahan aturan/arsitektur hanya via keyword resmi.",
    ],
  };
  if (["KACAB_SBY", "KACAB_SMD"].includes(role)) return {
    title: "SOP Approval & Monitoring (Kepala Cabang)",
    points: [
      "Setujui / TOLAK Work Order region Anda (approve & reject Kacab-only; satu WO satu klub).",
      "Kelola Master Diskon & harga MODAL klub region Anda (cost_price). Harga JUAL store BUKAN wewenang Anda — itu wewenang mutlak Staff Store; Anda HANYA MELIHAT.",
      "Input/kelola Saldo Awal (satu batch satu jenis) & Stock Opname (JUAL saja).",
      "Setujui Tukar Barang yang sudah lewat 7 hari (isi alasan — wajib).",
      "Setujui / TOLAK pengajuan Batalkan Produksi (dokumen BTL) untuk Work Order region Anda — Anda tidak boleh menyetujui bila Anda sendiri yang mengajukan.",
    ],
  };
  if (G(role)) return {
    title: "SOP Gudang (Admin Gudang)",
    points: [
      "Scan terima barang produksi (receive) ke gudang region Anda.",
      "Siapkan & scan dispatch untuk transfer / pengiriman.",
      "Terima retur dari store via scan — termasuk barang cacat dari Tukar Barang.",
      "MoU tetap dicatat & dicetak labelnya, tapi tidak dijual/ditagih.",
    ],
  };
  if (["ADMIN_PRODUKSI_SBY", "ADMIN_PRODUKSI_SMD"].includes(role)) return {
    title: "SOP Produksi (Admin Produksi)",
    points: [
      "Buat Work Order (satu WO = satu klub) lalu ajukan ke Kepala Cabang.",
      "Setelah disetujui: tandai 'Selesai Produksi', lalu 'Kirim ke Gudang'.",
      "QR baru dibuat saat 'Kirim ke Gudang' — cetak label thermal (skala 100%).",
      "Tindak lanjuti WO yang ditolak Kepala Cabang.",
      "Ajukan Batalkan Produksi (dokumen BTL) untuk Work Order region Anda bila perlu — isi alasan (wajib); Kepala Cabang region yang menyetujui/menolak.",
    ],
  };
  if (["STAFF_STORE_AREMA", "STAFF_STORE_BORNEO"].includes(role)) return {
    title: "SOP Store (Staff Store)",
    points: [
      "Terima kiriman dari gudang (scan/konfirmasi).",
      "Isi & revisi harga jual (S–XL & size besar 2XL–7XL) sendiri — berkali-kali, tanpa penguncian, tanpa persetujuan. Harga jual di bawah harga modal ditolak. Size besar tanpa harga tidak bisa dijual.",
      "Kasir: scan barang, pilih diskon dari master, cetak invoice.",
      "Bayar Nanti (piutang): pilih di kasir bila pembeli belum bayar — WAJIB isi \"Untuk Siapa\". Barang tetap keluar; tagih & terima pelunasan di menu Piutang.",
      "Tukar Barang: HANYA barang cacat, pengganti identik, maksimal 7 hari.",
    ],
  };
  return { title: "SOP", points: ["Hubungi admin untuk penetapan role."] };
};


// roleTag: petakan role user -> tag SOP untuk filter "SOP untuk role saya".
export const roleTag = (role) => {
  if (role === "OWNER") return "OWNER";
  if (["KACAB_SBY", "KACAB_SMD"].includes(role)) return "KACAB";
  if (["ADMIN_GUDANG_SBY", "ADMIN_GUDANG_SMD"].includes(role)) return "GUDANG";
  if (["ADMIN_PRODUKSI_SBY", "ADMIN_PRODUKSI_SMD"].includes(role)) return "PRODUKSI";
  if (["STAFF_STORE_AREMA", "STAFF_STORE_BORNEO"].includes(role)) return "STORE";
  return "ALL";
};

export const ROLE_TAG_LABEL = {
  OWNER: "Owner", KACAB: "Kepala Cabang", GUDANG: "Admin Gudang",
  PRODUKSI: "Admin Produksi", STORE: "Staff Store", ALL: "Semua Role",
};

// === SOP Detail menyeluruh (bahasa sederhana untuk staff lapangan) ===
// "external" = dibaca semua orang. "internal" (Proses Internal/Sistem) = hanya OWNER & KACAB.
export const SOP_DETAIL = [
  {
    code: "SOP-00", title: "Login & Akses", roles: ["ALL"],
    summary: "Login pakai akun Google. Akun baru menunggu didaftarkan Owner. Menu & data mengikuti peran dan wilayah Anda.",
    external: [
      "Buka aplikasi, klik 'Login dengan Google'.",
      "Kalau email Anda belum didaftarkan Owner, Anda belum bisa masuk — hubungi Owner.",
      "Menu dan data yang tampil otomatis menyesuaikan peran & wilayah (region) Anda.",
    ],
    internal: [
      "Supabase Auth (Google) menerbitkan JWT berisi klaim role & region (via custom access token hook).",
      "Backend memverifikasi token dan menerapkan Row-Level Security (RLS) per region.",
      "Email tak terdaftar di Role Matrix → status PENDING (tanpa akses operasional).",
    ],
  },
  {
    code: "SOP-01", title: "Merchandise & Harga Jual", roles: ["KACAB", "STORE", "OWNER"],
    summary: "Kepala Cabang mengisi & merevisi harga MODAL (per klub region). Harga JUAL (S–XL & 2XL–7XL) & status dijual/tidak = wewenang mutlak Staff Store store-nya — isi & revisi berkali-kali tanpa penguncian; Owner/Kacab hanya melihat.",
    external: [
      "Harga MODAL: diisi & direvisi Kepala Cabang region (atau Owner). Staff Store hanya melihat.",
      "RENCANA JUAL: di tab 'Harga Jual Store' klik [Atur] -> pilih Ya/Tidak dijual -> centang size -> isi harga. Alur: tentukan rencana jual -> centang size -> isi harga.",
      "'Tidak dijual di store' hanya menyembunyikan dari kasir. Barang TETAP bisa masuk Work Order (Jual/MoU), dapat QR, masuk gudang, dan muncul di Rekap Stok & Rekap MoU. Rencana jual TIDAK menghalangi produksi.",
      "Harga JUAL: diisi & direvisi oleh Staff Store — berkali-kali, tanpa penguncian — berlaku sama untuk S–XL, size besar 2XL–7XL, dan barang tanpa size. Harga jual DITOLAK bila di bawah harga modal.",
      "Menentukan dijual/tidak dijual & mengisi/merevisi harga jual = WEWENANG MUTLAK Staff Store store-nya. Owner & Kepala Cabang HANYA MELIHAT. Owner dapat memakai Assist Mode sebagai Staff Store bila perlu (tindakan tetap tercatat atas nama Owner). Menandai 'tidak dijual' DITOLAK bila masih ada stok barang itu di store — retur dulu ke gudang.",
      "PERINGATAN: size besar yang harga jualnya BELUM diisi TIDAK BISA DIJUAL. Kasir menolak saat scan QR: 'Harga jual untuk size {size} belum diisi. Isi dulu di menu Merchandize.' Tidak ada harga cadangan.",
      "Harga modal size besar otomatis ditambah surcharge oleh sistem (2XL +10.000 · 3XL +15.000 · 4XL +20.000 · 5XL +25.000 · 6XL +30.000 · 7XL +35.000) dan ikut masuk Invoice Penagihan ETAMS. Kepala Cabang cukup mengisi modal dasar.",
      "Barang nonaktif tidak muncul saat transaksi.",
    ],
    internal: [
      "Tabel products (+ SKU auto-generate, unik), store_prices (S–XL/tanpa size), store_size_prices (2XL–7XL), store_product_plan (rencana jual per-store, ADDITIF, RLS region).",
      "Rencana jual: PUT /store-sell-plan (set awal & revisi = Staff Store store-nya; Owner via Assist Mode). TIDAK ADA baris = 'belum ditentukan'.",
      "Harga jual: set awal & revisi POST/PUT /store-prices|/store-size-prices HANYA Staff Store store-nya (region guard). Owner-tanpa-Assist & Kepala Cabang -> 403 (hanya melihat). Harga jual < harga modal ditolak.",
      "Rencana jual TIDAK dibaca kasir/WO/ledger — hanya menyaring menu jual. Jenis Stok (Jual/MoU) tetap per unit lewat QR (ATURAN §7).",
      "SUMBER KEBENARAN (merchandise_v2.py:95-111, _require_store_writer): mengisi/merevisi harga jual & menandai dijual/tidak = wewenang MUTLAK Staff Store store-nya, tanpa penguncian/persetujuan/antrean. Owner-tanpa-Assist & Kepala Cabang ditolak 403. Kepala Cabang TETAP berwenang atas harga MODAL (cost_price).",
      "Harga modal sengaja terlihat Staff Store: dasar Invoice Penagihan klub. Surcharge size besar masuk cost_price snapshot per transaksi.",
      "Merchandise tanpa harga jual (sell_plan='YES') memicu notifikasi 'merch_no_price'.",
    ],
  },
  {
    code: "SOP-02", title: "Work Order & Produksi", roles: ["PRODUKSI", "KACAB", "OWNER"],
    summary: "Satu WO = satu klub. Approve & TOLAK hanya oleh Kepala Cabang. Dua langkah: 'Selesai Produksi' lalu 'Kirim ke Gudang'. QR dibuat saat kirim ke gudang.",
    external: [
      "Admin Produksi membuat WO (satu WO hanya untuk satu klub) lalu mengajukannya.",
      "Kepala Cabang MENYETUJUI atau MENOLAK (hanya Kepala Cabang yang boleh).",
      "Setelah disetujui: Admin Produksi menandai 'Selesai Produksi', lalu 'Kirim ke Gudang'.",
      "Saat 'Kirim ke Gudang', QR barang dibuat — cetak label thermal (skala 100%).",
    ],
    internal: [
      "Item + QR + movement PRODUCED dibuat HANYA saat 'Kirim ke Gudang' (bukan saat approve / selesai produksi).",
      "Approve & reject KACAB-ONLY. Satu WO satu klub (tidak dicampur).",
      "Status: Draft/Diajukan → Disetujui → Selesai Produksi → Dikirim ke Gudang.",
    ],
  },
  {
    code: "SOP-03", title: "Penerimaan Gudang", roles: ["GUDANG"],
    summary: "Admin Gudang menerima barang produksi dengan scan QR, hanya untuk gudang wilayahnya.",
    external: [
      "Scan QR barang yang datang dari produksi untuk menerimanya.",
      "Hanya bisa menerima ke gudang wilayah Anda.",
    ],
    internal: [
      "Movement MASUK_GUDANG; state PRODUCED → IN_WAREHOUSE (ledger append-only).",
    ],
  },
  {
    code: "SOP-04", title: "Transfer Antar Gudang", roles: ["GUDANG", "KACAB", "OWNER"],
    summary: "Siapkan transfer → kirim (dispatch) dari gudang asal → terima di gudang tujuan. Surat Jalan PDF.",
    external: [
      "Kepala Cabang MEMBUAT pengajuan transfer & memilih barang (documents_v2.py:89-95). Admin Gudang hanya dispatch (kirim) & receive (terima).",
      "Gudang asal mengirim (dispatch); gudang tujuan menerima dengan scan. Cetak Surat Jalan (PDF).",
    ],
    internal: [
      "TRANSFER_DIKIRIM/DITERIMA; IN_WAREHOUSE → IN_TRANSFER → IN_WAREHOUSE.",
      "EXACT-MATCH saat dispatch & receive: jumlah/daftar barang harus PERSIS sama dengan dokumen. Kurang, lebih, atau beda unit → DITOLAK TOTAL (tidak ada penerimaan/pengiriman sebagian). Sumber: SOP.md:217-235.",
      "Pembatalan pakai CANCEL_REVERSAL (append-only) — mengembalikan stok ke gudang asal.",
    ],
  },
  {
    code: "SOP-05", title: "Pengiriman ke Store", roles: ["GUDANG", "STORE", "KACAB"],
    summary: "Kepala Cabang membuat pengajuan pengiriman; Gudang dispatch ke store wilayah; Staff Store menerima dengan scan. Surat Jalan PDF.",
    external: [
      "Kepala Cabang MEMBUAT pengajuan pengiriman ke store (documents_v2.py:89-95); Admin Gudang menyiapkan & mengirim (dispatch).",
      "Staff Store menerima kiriman dengan scan QR. Cetak Surat Jalan (PDF).",
    ],
    internal: [
      "DIKIRIM_KE_STORE → DITERIMA_STORE; IN_WAREHOUSE → IN_SHIPMENT → IN_STORE.",
      "EXACT-MATCH saat dispatch & receive: kurang/lebih/beda unit → DITOLAK TOTAL, tidak ada penerimaan sebagian (SOP.md:217-235).",
      "Pembatalan pakai CANCEL_REVERSAL — mengembalikan stok ke gudang.",
    ],
  },
  {
    code: "SOP-06", title: "Penjualan & Invoice (Kasir)", roles: ["STORE"],
    summary: "Staff Store scan barang, pilih diskon dari master aktif, terima pembayaran, cetak invoice.",
    external: [
      "Scan barang yang dijual, pilih diskon (dari Master Diskon), terima pembayaran.",
      "Cetak invoice/struk untuk pelanggan.",
      "Hanya Staff Store yang memakai diskon saat menjual. Barang MoU tidak boleh dijual.",
    ],
    internal: [
      "invoices + invoice_lines; movement TERJUAL. Formula penjualan bersifat sacred (tidak diubah).",
      "Diskon diambil dari master aktif per klub/region; beban ETAMS%+klub% = besaran diskon.",
    ],
  },
  {
    code: "SOP-07", title: "Retur", roles: ["STORE", "GUDANG"],
    summary: "Store membuat retur + alasan → dikirim → Gudang menerima (scan). Barang cacat dari Tukar Barang digabungkan manual oleh Staff Store lewat alur ini.",
    external: [
      "Staff Store membuat retur dengan alasan, lalu mengirimnya ke gudang.",
      "Admin Gudang menerima retur dengan scan.",
      "Barang cacat hasil Tukar Barang TERTAHAN di store — Staff Store sendiri yang membuatkan dokumen retur, kapan saja, tanpa persetujuan, dan BOLEH digabung dengan retur biasa dalam satu dokumen.",
      "Surat Jalan Retur & Tanda Terima tersedia sebagai bukti PDF; tiap baris menampilkan status CACAT atau NORMAL beserta alasan/asalnya.",
    ],
    internal: [
      "RETUR_DIKIRIM → RETUR_DITERIMA_GUDANG. Muncul di Laporan Mutasi.",
      "Barang cacat = bukan stok jual & bukan stok MoU; tampil di kelompok terpisah 'CACAT' di laporan stok (Excel ikut). PDF retur menandai baris cacat vs normal.",
    ],
  },
  {
    code: "SOP-08", title: "Tukar Barang (Barang Cacat)", roles: ["STORE", "KACAB", "OWNER"],
    summary: "HANYA untuk barang CACAT. Pengganti harus IDENTIK (produk, ukuran, kategori sama). Maksimal 7 hari dari nota. Tanpa uang; nota & tagihan tidak diubah.",
    external: [
      "Hanya barang CACAT yang boleh ditukar (bukan salah ukuran / salah kirim).",
      "Staff Store WAJIB memeriksa bukti foto/video & fisik barang, lalu mencentang konfirmasi verifikasi.",
      "Scan barang cacat, lalu scan barang pengganti yang IDENTIK (produk, ukuran, kategori JUAL sama).",
      "Batas maksimal 7 hari dari tanggal nota. Lewat 7 hari → perlu persetujuan Kepala Cabang (alasan wajib diisi).",
      "Tidak ada uang berpindah, tidak ada selisih harga, nota asli & tagihan TIDAK berubah.",
      "Barang cacat TERTAHAN di store sebagai 'barang cacat menunggu retur' (bukan stok jual/MoU). Buat dokumen retur manual lewat menu Retur — boleh digabung, tanpa batas waktu.",
    ],
    internal: [
      "exchanges (link ke nota asli). Barang lama SOLD → IN_RETURN + defect=true; pengganti IN_STORE → SOLD (append-only CANCEL_REVERSAL).",
      "Satu barang lama tak bisa ditukar 2×; satu pengganti tak bisa dipakai 2 tukar (index idempoten + guard 409).",
      "Override >7 hari: hanya Kacab region, alasan non-kosong, tercatat (siapa/kapan/alasan). Billing Opsi A (tak disentuh).",
    ],
  },
  {
    code: "SOP-09", title: "Compliment", roles: ["STORE", "KACAB", "GUDANG", "OWNER"],
    summary: "Barang keluar tanpa penjualan (compliment). TANPA nilai uang. Compliment lewat kasir Staff Store AKTIF (STORE_COMPLIMENT_ENABLED = true).",
    external: [
      "Compliment = barang keluar tanpa dijual, atas persetujuan.",
      "Staff Store BISA membuat Compliment di kasir. WAJIB mengisi 'untuk siapa'. Biaya barang ditanggung ETAMS dan TIDAK ditagihkan ke klub.",
      "Jalur lain tetap tersedia: Kepala Cabang lewat proses requisition / compliment gudang.",
      "Compliment tidak punya nilai uang dan tidak dihitung sebagai omzet.",
    ],
    internal: [
      "Flag STORE_COMPLIMENT_ENABLED = true (produksi) mengaktifkan compliment kasir Staff Store; biaya ditanggung ETAMS, tidak masuk penagihan klub.",
      "Compliment value-free: total 0, tidak masuk Laporan Penjualan.",
    ],
  },
  {
    code: "SOP-10", title: "Permintaan Merchandize", roles: ["STORE", "KACAB", "OWNER"],
    summary: "Staff Store membuat/revisi/batal sebelum disetujui; Kepala Cabang setujui/tolak. Approve TIDAK otomatis membuat Work Order — keputusan produksi tetap di tangan manusia.",
    external: [
      "Staff Store membuat, merevisi, atau membatalkan permintaan sebelum disetujui.",
      "Kepala Cabang menyetujui/menolak (wilayahnya). Owner memantau.",
      "Permintaan yang ditolak boleh direvisi lalu diajukan ulang.",
    ],
    internal: [
      "Approve hanya mengubah status jadi APPROVED (store_requests_v2.py:456-466). TIDAK ada Auto-WO; Admin Produksi membuat Work Order secara manual bila diputuskan.",
    ],
  },
  {
    code: "SOP-11", title: "Saldo Awal", roles: ["KACAB", "OWNER"],
    summary: "Mencatat stok awal barang yang BELUM TERJUAL. Satu batch = satu jenis (JUAL atau MoU). Isi semua ukuran sekaligus. Cetak label.",
    external: [
      "Saldo Awal HANYA untuk barang yang BELUM pernah terjual.",
      "Barang yang sudah terjual TIDAK boleh dimasukkan di sini (administrasi lama diurus manual di luar aplikasi).",
      "Satu batch hanya untuk SATU jenis: JUAL saja, atau MoU saja.",
      "Untuk satu produk, isi jumlah semua ukuran sekaligus (ukuran berisi 0 dilewati).",
      "Setelah diposting, label QR bisa dicetak.",
    ],
    internal: [
      "Batch DRAFT → VERIFIED → POSTED; ledger OPENING_BALANCE. Jenis terkunci di level batch.",
      "Koreksi MoU pakai OPENING_BALANCE_ADJUSTMENT / OPENING_VOID (bukan opname).",
    ],
  },
  {
    code: "SOP-12", title: "Master Diskon", roles: ["OWNER", "KACAB"],
    summary: "Daftar diskon per klub/region. Owner kelola semua region; Kepala Cabang kelola wilayahnya. Beban ETAMS% + klub% harus sama dengan besaran diskon.",
    external: [
      "Diskon diatur per klub/region (bukan lagi angka tetap di sistem).",
      "Owner mengatur semua region; Kepala Cabang mengatur klub/region-nya sendiri.",
      "Pembagian beban: persentase ETAMS + persentase klub HARUS sama dengan besar diskonnya.",
      "Hanya Staff Store yang memakai diskon ini saat menjual.",
    ],
    internal: [
      "Tabel discounts (master per klub/region) + snapshot beban saat billing. Billing pakai snapshot beban, bukan diskon/2.",
    ],
  },
  {
    code: "SOP-13", title: "Stock Opname", roles: ["KACAB", "OWNER"],
    summary: "Hitung ulang stok fisik. HANYA untuk barang JUAL. Barang MoU dikecualikan sepenuhnya.",
    external: [
      "Opname = hitung ulang stok fisik lalu posting selisihnya.",
      "Opname HANYA untuk barang JUAL. Barang MoU tidak ikut dihitung dan tidak boleh berubah.",
    ],
    internal: [
      "OPEN → COUNTING → POSTED; selisih → movement ADJUSTMENT. Saat kurang, pemilihan unit WAJIB filter kategori 'Jual'.",
    ],
  },
  {
    code: "SOP-14", title: "Barang MoU", roles: ["ALL"],
    summary: "MoU = barang kerja sama, BUKAN untuk dijual. Tidak dijual, tidak ditagih, tidak di-opname. Label QR tetap dicetak. MoU di store bukan stok jualan.",
    external: [
      "Barang MoU TIDAK dijual dan TIDAK masuk penagihan.",
      "MoU tidak ikut Stock Opname.",
      "Label QR MoU TETAP dicetak seperti biasa.",
      "MoU yang ada di store dianggap sudah diserahkan ke klub — bukan stok jualan (lihat Rekap MoU, bukan Rekap Stok).",
    ],
    internal: [
      "Kategori MELEKAT pada unit sejak WO/QR dan tidak boleh berubah oleh proses apa pun.",
      "Rekap Stok mengecualikan MoU di lokasi STORE; MoU di gudang tetap tampil.",
    ],
  },
  {
    code: "SOP-15", title: "Cetak Label QR", roles: ["PRODUKSI", "GUDANG", "STORE", "KACAB", "OWNER"],
    summary: "Label QR dicetak di printer thermal ukuran 50×40mm. Cetak pada skala 100% (jangan diperbesar/diperkecil).",
    external: [
      "Cetak label di printer thermal ukuran 50×40mm.",
      "Saat mencetak, pastikan skala 100% (ukuran asli) agar QR terbaca scanner.",
      "Label tersedia untuk barang WO dan barang Saldo Awal; barang MoU juga dicetak labelnya.",
    ],
    internal: [
      "Endpoint PDF label (wo-labels / saldo-awal labels), read-only; MoU dikecualikan hanya dari opname/penjualan, bukan dari pencetakan label.",
    ],
  },
  {
    code: "SOP-16", title: "Laporan & Export Excel", roles: ["OWNER", "KACAB", "STORE", "GUDANG"],
    summary: "Laporan Penjualan (JUAL saja), Rekap Stok, Rekap MoU, dan Mutasi + export Excel. Cakupan data mengikuti wilayah Anda.",
    external: [
      "Lihat Laporan Penjualan (hanya JUAL), Rekap Stok, Rekap MoU, dan Mutasi.",
      "Export tiap laporan ke Excel (.xlsx).",
      "Data yang tampil mengikuti peran & wilayah Anda.",
    ],
    internal: [
      "Agregasi read-only dari ledger stock_movements & invoices; timezone Asia/Jakarta.",
      "Compliment dikecualikan dari omzet; Rekap Stok mengecualikan MoU di STORE.",
    ],
  },
  {
    code: "SOP-17", title: "Manajemen User (Role Matrix)", roles: ["OWNER"],
    summary: "Owner mendaftarkan email per peran (maksimal 2 email/peran). Email terdaftar langsung bisa login & otomatis dapat peran.",
    external: [
      "Owner mengisi email untuk tiap peran pada matrix, lalu Save.",
      "Email yang terdaftar langsung bisa login Google dan otomatis mendapat perannya.",
      "Maksimal 2 email per peran; akun Owner dilindungi.",
    ],
    internal: [
      "Tabel user_role_slots; trigger handle_new_user memetakan email → role+region. Email dihapus → demote PENDING (record tak dihapus).",
    ],
  },
  {
    code: "SOP-18", title: "QR Tracking & Audit", roles: ["OWNER", "KACAB", "PRODUKSI"],
    summary: "Telusuri riwayat pergerakan satu barang (QR) dan jejak aktivitas dari ledger.",
    external: [
      "Masukkan/scan QR untuk melihat riwayat lengkap pergerakan barang tersebut.",
    ],
    internal: [
      "Sumber: ledger stock_movements (pergerakan) + ledger_event_log (aksi pengguna).",
    ],
  },
  {
    code: "SOP-19", title: "Backup & Restore", roles: ["OWNER"],
    summary: "Backup database terjadwal via GitHub Actions ke Google Cloud Storage (2x/hari), plus sinkronisasi object storage R2 → GCS (1x/hari). Restore lewat modul backup_v2.py (Owner-only).",
    external: [
      "Backup database berjalan terjadwal otomatis (GitHub Actions → Google Cloud Storage), 2x sehari (02:00 & 14:00 UTC).",
      "File PDF/arsip di object storage (Cloudflare R2) disinkronkan ke GCS 1x sehari (03:00 UTC) — object storage IKUT tercakup.",
    ],
    internal: [
      ".github/workflows/backup-etamsinv-gcs.yml (DB 02:00 & 14:00 UTC; R2→GCS 03:00 UTC). Restore/operasi backup lewat backend/routers/backup_v2.py (Owner-only).",
    ],
  },
  {
    code: "SOP-20", title: "Bayar Nanti (Piutang)", roles: ["STORE", "OWNER", "KACAB"],
    summary: "Penjualan yang barangnya diambil dulu, dibayar kemudian. Belum masuk penagihan sampai dilunasi; setelah lunas masuk penagihan pada periode PEMBAYARAN.",
    external: [
      "Di kasir, aktifkan \"Bayar Nanti\" HANYA bila pembeli belum membayar. Fitur ini hanya untuk transaksi Jual (bukan Compliment/MoU).",
      "WAJIB isi \"Untuk Siapa\" (nama penerima/klub). Tombol simpan mati sampai diisi.",
      "Barang tetap KELUAR seperti penjualan biasa (stok berkurang), tetapi transaksi ini BELUM masuk penagihan.",
      "Saat pembeli melunasi, buka menu Piutang → \"Terima Pembayaran\" → konfirmasi. Pelunasan HARUS sekaligus (tidak ada cicilan). Tidak ada batas waktu.",
      "Hanya Staff Store yang boleh menerima pembayaran, dan hanya untuk piutang store-nya sendiri.",
      "Rekap Piutang dikelompokkan per \"Untuk Siapa\" dan menampilkan umur utang, supaya mudah ditagih.",
      "Selama belum lunas, klub tetap bertanggung jawab atas piutang tersebut.",
    ],
    internal: [
      "Billing memakai Cara B: invoice normal tetap difilter tanggal transaksi; invoice Bayar Nanti hanya masuk billing bila status PAID/FORCED, pada periode paid_at (server now(), tak bisa di-backdate).",
      "Harga/diskon/beban dikunci saat transaksi (snapshot invoice_lines) — TIDAK dihitung ulang saat pelunasan.",
      "Pelunasan idempoten (row-lock FOR UPDATE + cek status): satu invoice tak bisa dilunasi dua kali (409).",
      "Force Bill: OWNER-only, alasan tertulis WAJIB, tercatat di audit (force_reason + ledger_event_log). Status jadi FORCED, masuk billing periode berjalan; klub tetap bertanggung jawab.",
      "Billing periode yang sudah terbit tidak berubah oleh pelunasan mana pun (bukti: A tetap melalui banyak regenerate).",
    ],
  },
  {
    code: "SOP-21", title: "Batalkan Produksi", roles: ["PRODUKSI", "KACAB", "OWNER"],
    summary: "Membatalkan Work Order yang sudah diproduksi lewat DOKUMEN bernomor BTL (bukan tombol sekali klik). Admin Produksi mengajukan, Kepala Cabang region yang sama menyetujui/menolak. Setelah disetujui bersifat PERMANEN.",
    external: [
      "Batalkan Produksi berbentuk DOKUMEN bernomor (seri BTL), bukan tombol sekali klik.",
      "ADMIN PRODUKSI region Work Order itu yang MENGAJUKAN. Alasan pembatalan WAJIB diisi.",
      "KEPALA CABANG region yang SAMA yang MENYETUJUI atau MENOLAK.",
      "Pengaju TIDAK BOLEH menyetujui ajuannya sendiri.",
      "Owner hanya melihat; bila ingin bertindak harus lewat Assist Mode.",
      "Setelah DISETUJUI bersifat PERMANEN — tidak bisa dibatalkan. Jalan keluarnya: membuat Work Order baru.",
      "Unit yang gagal diproses dilaporkan satu per satu dan TIDAK menggagalkan unit yang sehat.",
    ],
    internal: [
      "Dokumen BTL (production_cancel_v2.py). Pengajuan: Admin Produksi region WO + alasan wajib. Persetujuan/penolakan: Kepala Cabang region sama; pengaju ≠ penyetuju (ditolak bila sama).",
      "Owner read-only kecuali via Assist Mode. Status PERMANEN pasca-approve (tidak ada pembatalan; buat WO baru). Kegagalan per-unit dilaporkan tanpa menggagalkan batch sehat.",
    ],
  },
  {
    code: "SOP-22", title: "Batalkan Transaksi Penjualan", roles: ["STORE", "KACAB", "OWNER"],
    summary: "Membatalkan transaksi penjualan yang salah input lewat DOKUMEN bernomor BTJ (bukan tombol sekali klik). Staff Store mengajukan, Kepala Cabang region yang sama menyetujui/menolak. Saat disetujui: barang kembali ke store, invoice ditandai batal, dan seluruh laporan serta penagihan otomatis mengecualikannya. Setelah disetujui bersifat PERMANEN.",
    external: [
      "Batalkan Transaksi berbentuk DOKUMEN bernomor (seri BTJ), bukan tombol sekali klik.",
      "STAFF STORE mengajukan pembatalan transaksi penjualan store-nya SENDIRI. KEPALA CABANG region yang SAMA menyetujui atau menolak. Owner hanya melihat (bertindak lewat Assist Mode). Pengaju TIDAK BOLEH menyetujui ajuannya sendiri.",
      "Alasan WAJIB dua bagian: pilih alasan (Salah jenis transaksi / Salah barang / Salah diskon / Pembeli batal) DAN isi keterangan (tidak boleh kosong).",
      "R1/R2 — Kalau Invoice Penagihan ke klub untuk store & bulan itu SUDAH terbit (ACTIVE), pembatalan DITOLAK sistem. Tidak ada jalan pintas, tidak ada override peran mana pun. Karena itu ajukan pembatalan SEBELUM penagihan bulan itu dibuat.",
      "R3 — SEMUA barang di nota itu harus masih di store (belum diretur, ditukar, atau dipindah). Kalau ada satu saja yang sudah bergerak, SELURUH pembatalan ditolak (tidak ada pembatalan sebagian).",
      "R4 — Transaksi Bayar Nanti yang SUDAH lunas/ditagih paksa TIDAK bisa dibatalkan. Yang belum lunas boleh; saat disetujui, piutangnya ikut dibatalkan.",
      "Saat disetujui: barang otomatis KEMBALI ke store (bisa dijual lagi atau diinput ulang, mis. sebagai Compliment), invoice ditandai DIBATALKAN, dan penjualan itu tidak lagi ikut di laporan/omzet/PPN/penagihan.",
      "Setelah DISETUJUI bersifat PERMANEN — tidak ada pembatalan atas pembatalan.",
    ],
    internal: [
      "Dokumen BTJ (sale_cancel_v2.py). Pengajuan: Staff Store store sendiri (reason_code dari daftar tetap + reason_note wajib). Persetujuan/penolakan: Kepala Cabang region sama; pengaju ≠ penyetuju.",
      "Lima aturan (R1-R5) diperiksa DUA KALI: saat ajukan dan sekali lagi saat setujui. R1/R2 = billings ACTIVE store+periode → tolak. R3 = semua unit harus SOLD (all-or-nothing). R4 = Bayar Nanti PAID/FORCED ditolak; UNPAID → credit_status jadi CANCELLED saat approve. R5 = reason_code+reason_note wajib.",
      "Approve = movement APPEND-ONLY CANCEL_REVERSAL per unit (to_location=store, IN_STORE); bila ADA unit gagal, SELURUH transaksi rollback & dokumen tetap DIAJUKAN. Invoice diberi cancelled_at/by/cancellation_id. Semua perhitungan penjualan/penagihan/PPN menyaring cancelled_at IS NULL.",
    ],
  },
];
